<template>
  <div class="page">
    <query-form label-width="90px">
      <template v-slot:formitem>
        <query-form-item :label="$t('common.dateRange')">
          <el-date-picker
            v-model="daterange"
            type="daterange"
            :editable="false"
            :start-placeholder="$t('common.startDate')"
            :end-placeholder="$t('common.endDate')"
            value-format="timestamp"
            :default-time="['00:00:00', '23:59:59']"
            style="width: 100%"
          >
          </el-date-picker>
        </query-form-item>
      </template>
      <template>
        <el-button class="mb10" type="primary" @click="search">{{ $t('common.search') }}</el-button>
        <el-button class="mb20" type="info" @click="reset">{{ $t('common.reset') }}</el-button>
      </template>
    </query-form>

    <el-table class="spacing-table" v-loading="loading" :data="tableData">
      <el-table-column prop="taskName" :label="$t('common.taskName')" min-width="150"></el-table-column>
      <el-table-column prop="createdAt" :label="$t('common.startDate')" min-width="150"></el-table-column>
      <el-table-column :label="$t('common.status')">
        <template slot-scope="scope">
          <span
            :class="{
              green: scope.row.status === 'Success' || scope.row.status === '成功',
              red: scope.row.status === 'Failed' || scope.row.status === '失败',
            }"
            >{{ scope.row.status }}</span
          >
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.wasteTime')" min-width="100">
        <template slot-scope="scope">
          {{ scope.row.costTime != null ? scope.row.costTime / 1000 + $t('common.s') : '' }}
        </template>
      </el-table-column>
      <el-table-column width="150" :label="$t('common.action')">
        <template slot-scope="scope">
          <el-button type="text" v-if="scope.row.status !== '导出中' && scope.row.status !== 'Exporting'" @click="downloadResult(scope.row)"
            >{{ $t('common.download', [' ']) }}{{ $t('common.result') }}</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import { importOrExportManagerTask } from '../../api/product';
import { downloadUrlFile } from '../../common/utils';

export default {
  name: 'ProductExport',
  data() {
    return {
      loading: false,
      daterange: [],
      queryForm: {
        pageNo: 1,
        pageSize: 25,
      },
      total: 0,
      tableData: [],
    };
  },
  created() {
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.daterange = [];
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    getTableData() {
      this.loading = true;
      importOrExportManagerTask({
        ...this.queryForm,
        taskCode: 'portal_excel_export_product',
        starDate: this.daterange ? this.daterange[0] : null,
        endDate: this.daterange ? this.daterange[1] : null,
      }).then((res) => {
        this.total = res.data.total || 0;
        this.tableData = res.data.list || [];
        this.loading = false;
      });
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    downloadResult(row) {
      try {
        const res = JSON.parse(row.data);
        downloadUrlFile(res.resultUrl);
      } catch (error) {
        // nothing
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
